import React from 'react';

export default function About() {
    return(
        <div className='section tealBackground'>
            <h1 className='sectionHeader topHeader'>About Me</h1>
            <p className='sectionText'>
                    My name is Scott McNamara. I have been making durable, custom painted cornhole boards since 2017. I've lived in Wall Township since 2006. I'm a proud stay at home dad of 3 who took up woodworking as a hobby in 2012.
                </p>
        </div>
    );

}